import { useQuery } from "react-query";
import { _AccountApi } from "api/account/account";

export const useCoockies = () => {
  const { data, isLoading } = useQuery(
    ["cookis"],
    () => _AccountApi.cookies().then((res) => res),
    {
      keepPreviousData: true,
    }
  );
  return {
    data,
    isLoading,
  };
};
